import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { authReducer } from '../reducers/authSlice';
import logger from 'redux-logger';
import { chatAdminReducer } from '../reducers/chatAdminSlice';
import { maintenanceReducer } from '../reducers/maintenanceSlice';
import { adminApi } from '../api/adminApi/adminApi';


const reducers = combineReducers(
  {
    chatAdmin: chatAdminReducer,
    auth: authReducer,
    maintenance: maintenanceReducer,

    [adminApi.reducerPath]: adminApi.reducer,
  });

export const store = configureStore({
  reducer: reducers,
  middleware: (getDefaultMiddleware) => {
    return process.env.NODE_ENV === 'development' ?
      getDefaultMiddleware({ serializableCheck: false }).concat(logger).concat(adminApi.middleware) :
      getDefaultMiddleware({ serializableCheck: false }).concat(adminApi.middleware);
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
